import { Chip, Grid, Typography } from '@mui/material';
import { Asset } from 'vendor-marketplace-shared-library';

type PropertyAssetsContainerProps = {
  assets: Asset[];
};

export function PropertyAssetsContainer(props: PropertyAssetsContainerProps) {
  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item>
        <Typography variant={'h6'}>Assets</Typography>
      </Grid>
      <Grid item container spacing={2}>
        {props.assets.length > 0 ? (
          props.assets.map((asset: Asset) => (
            <Grid item key={asset.id}>
              <Chip variant='outlined' sx={styles.chip} label={`${asset.make} - ${asset.model}`} />
            </Grid>
          ))
        ) : (
          <Grid item>
            <Typography>No assets to show.</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    rowGap: 2,
    padding: 2,
    borderRadius: 2,
    backgroundColor: 'secondary.light',
  },
  chip: {
    backgroundColor: 'white',
    borderColor: 'black',
    borderRadius: 1,
  },
};
